package team.platforma.dictionary_domain.use_case.ai_model

import team.platforma.dictionary_data.repository.ai_model.AiModelRepository

class NetworkAiModelUseCase(
    private val repository: AiModelRepository
) {
    suspend fun load() {
        repository.load()
    }
}